<template>
  <div class="content">

    <loading
      name="lp"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <base-header class="pb-6">
      <div class="row align-items-center py-0"></div>
    </base-header>

    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-5 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row">
              <div class="col-lg-3 col-sm-12">
                <base-button outline type="primary" block @click="onBack()">
                  <span class="btn-inner--icon">
                    <i class="ni sign-left"></i>
                  </span>
                  Back to main page</base-button
                >
              </div>
            </div>

            <h3 class="mb-0 mt-4">Timeline</h3>
            <!-- <p class="text-sm mb-0">Agenda</p> -->
          </template>
          <div class="row mb-4">
            <div class="col-lg-4">
              <el-select
                class="select-primary pagination-select"
                v-model="filter.id"
                placeholder="Class"
                style="width: 100%"
                @change="onGo"
              >
                <el-option
                  class="select-primary"
                  v-for="item in classes"
                  :key="item.id"
                  :label="item.code + ' ' + item.coursetitle"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <card>
                <ul class="list-group list-group-flush list my--3">
                  <li class="list-group-item px-0">
                    <div class="row align-items-center">
                      <div class="col-lg-2">
                        <img
                          :src="
                            !cls.picture
                              ? nophoto
                              : fileurl + cls.picture
                          "
                          class="avatar rounded-circle mr-3"
                        />
                      </div>
                      <div class="col-lg-10">
                        <h5>{{ cls.code }}. {{ cls.coursetitle }}</h5>
                        <span style="font-size: 12px"
                          >Duration: {{ cls.courseduration }} week(s)</span
                        ><br />
                        <span style="font-size: 12px"
                          >Start date: {{ cls.startdate }}</span
                        ><br />
                        <span style="font-size: 12px"
                          >{{
                            cls.enddate ? "Finished" : "Estimated finish date"
                          }}:
                          {{
                            cls.enddate ? cls.enddate : cls.calcenddate
                          }}</span
                        ><br />
                        <span v-if="cls.studentenddate" style="font-size: 12px; color: red; font-weight: bold"
                          >Cancel date: {{ cls.studentenddate }}</span
                        ><br />
                        <br />
                        {{ cls.resppersonname }}
                        <div v-if="!cls.studentenddate">
                        <base-progress
                          class="mb-0"
                          type="green"
                          :value="cls.progress"
                        ></base-progress>
                        <span style="font-size: 12px"
                          >{{ cls.progress }}% ({{ cls.finishedlessoncount }} of
                          {{ cls.totallessoncount }})</span
                        >
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </card>
              <card>
                <ul class="list-group list-group-flush list my--3 mt-10">
                  <li class="list-group-item px-0">
                    <div class="row align-items-center mb-2">
                      Present/Abcent, Mark
                    </div>
                    <div
                      class="row"
                      v-for="item in lessons.filter((c) => c.status > 4)"
                      :key="item.id"
                    >
                      <div class="col-lg-4">
                        <span style="font-size: 12px">{{
                          item.lessondatestr
                        }}</span>
                      </div>
                      <div class="col-lg-4">
                        <span
                          style="font-size: 12px"
                          :style="{ 'color: red': item.present === 0 }"
                          >{{ item.present === 1 ? "Present" : "Abcent" }}</span
                        >
                      </div>
                      <div class="col-lg-4">
                        <span v-if="item.mark > 0" style="font-size: 12px">{{
                          item.mark
                        }}</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </card>
            </div>
            <div class="col-lg-6">
              <time-line type="one-side" v-if="!cls.studentenddate">
                <time-line-item
                  v-for="item in sched"
                  :key="item.id"
                  :badge-type="type(item.status)"
                  :badge-icon="icon(item.status)"
                >
                  <small class="text-muted font-weight-bold">{{
                    item.lessondatestr ? item.lessondatestr : "Not scheduled"
                  }}</small>
                  <h4 class="mt-3 mb-0">
                    #{{ item.stageorderindex }}. {{ item.stagetitle }}
                  </h4>
                  <h5 class="mt-3 mb-0">
                    #{{ item.stageorderindex }}.{{ item.orderindex }}.
                    {{ item.title }}
                  </h5>
                </time-line-item>
              </time-line>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { TimeLine, TimeLineItem } from "@/components";
import BaseHeader from "@/components/BaseHeader";
import Badge from "@/components/Badge";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {
  GetClassesByStudent,
  GetLessons,
  GetScheduleByStudent,
} from "../../../services/classes";
import { nophoto, fileUrl } from "../../../services/helper";
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Badge,
    BaseHeader,
    TimeLine,
    TimeLineItem,
    Loading,
  },
  props: {
    id: String,
  },
  computed: {
    fileurl() {
      return fileUrl;
    },
    nophoto() {
      return nophoto;
    },
  },
  data() {
    return {
      tableData: [],
      classes: [],
      cls: {
        picture: null
      },
      sched: [],
      lessons: [],
      filter: {
        start: "2000-01-01",
        end: "2099-12-31",
        searchtype: 2,
        studentid: this.$store.state.user.id,
        id: this.id,
      },
      endDate: null,
      isLoading: false,
    };
  },
  methods: {
    onBack() {
      this.$router.push({ name: "StudentMain" }).catch((e) => {});
    },
    onGo() {
      this.isLoading = true;
      GetLessons(this.filter.id).then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          this.cls = this.classes.filter((c) => c.id === this.filter.id)[0];
          this.sched = response.data.result;

          GetScheduleByStudent(this.filter).then((response) => {
            this.isLoading = false;
            if (response.data.result) {
              this.lessons = response.data.result;
            }
          });
        } else {
          this.sched = [];
          if (response.data)
            this.notifyVue(
              "danger",
              response.data ? response.data : "No data found"
            );
        }
      });
    },
    type(status) {
      switch (status) {
        case 1:
          return "danger";
        case 2:
          return "warning";
        case 3:
          return "info";
        case 4:
          return "info";
        case 5:
          return "success";
      }
    },
    icon(status) {
      switch (status) {
        case 1:
          return "text-white ni t-warning";
        case 2:
          return "ni megaphone";
        case 3:
          return "text-blue ni hourglass";
        case 4:
          return "ni laptop";
        case 5:
          return "ni verified";
        case 6:
          return "";
      }
    },
  },
  mounted() {
    GetClassesByStudent(0, this.$store.state.user.id).then((response) => {
      if (response.data !== null) {
        this.classes = response.data.result;
        if (!this.filter.id) this.filter.id = this.classes[0].id;
        this.onGo();
      }
    });
  },
};
</script>
<style></style>
